export enum SUBSCRIPTION_CATEGORY {
    PROCUREX = 1,
    BUILDSPACE = 2
}
